import type { CartUI } from '@libs/common-node';

export function isAddItemCartResponseSuccessful(cart: CartUI | null | undefined): boolean {
    if (!cart?.id || !cart.basketId || !Array.isArray(cart.fulfillmentGroups)) {
        return false;
    }
    if (cart.status != null && cart.status >= 400) {
        return false;
    }
    return true;
}

export function summarizeAddItemCartResponseForLog(cart: CartUI | null | undefined): string {
    if (!cart) {
        return 'null';
    }
    return JSON.stringify({
        id: cart.id,
        hasBasketId: Boolean(cart.basketId),
        fulfillmentGroupsIsArray: Array.isArray(cart.fulfillmentGroups),
        payloadStatus: cart.status ?? null,
    });
}
